import { useMutation } from 'react-query'
import { createPeopleMerge } from 'services/people'
import { transformJobMappingsForAPI } from '../utils'

function usePeopleMergeMutation() {
  const { mutate: merge, isLoading, isSuccess, isError, error, reset } = useMutation(
    ({ sourceId, targetId, jobMappings }) => {
      const { jobMappings: apiMappings, jobOverrides } = transformJobMappingsForAPI(jobMappings)
      return createPeopleMerge(sourceId, targetId, apiMappings, jobOverrides)
    },
    {
      retry: false,
    },
  )

  return {
    merge,
    isLoading,
    isSuccess,
    isError,
    error,
    reset,
  }
}

export default usePeopleMergeMutation
